var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formData.id ? "編輯旅行社資料" : "新增旅行社資料",
            visible: _vm.dialogFormVisible,
            top: "2%",
          },
          on: {
            opened: function ($event) {
              return _vm.getTaiwanCitiesOption(2, false)
            },
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              ref: "dynamicValidateForm",
              attrs: { model: _vm.formData },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "旅行社代碼",
                    "label-width": _vm.formLabelWidth,
                    prop: "agencyCode",
                    rules: [
                      {
                        required: true,
                        message: "請輸入旅行社代碼",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { readonly: "", autocomplete: "off" },
                    model: {
                      value: _vm.formData.agencyCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "agencyCode", $$v)
                      },
                      expression: "formData.agencyCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "旅行社名稱",
                    "label-width": _vm.formLabelWidth,
                    prop: "agencyName",
                    rules: [
                      {
                        required: true,
                        message: "請輸入旅行社名稱",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.agencyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "agencyName", $$v)
                      },
                      expression: "formData.agencyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "旅行社簡稱",
                    "label-width": _vm.formLabelWidth,
                    prop: "agencyShortName",
                    rules: [
                      {
                        required: true,
                        message: "請輸入旅行社簡稱",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.agencyShortName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "agencyShortName", $$v)
                      },
                      expression: "formData.agencyShortName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "統一編號",
                    "label-width": _vm.formLabelWidth,
                    prop: "vatNumber",
                    rules: [
                      {
                        required: true,
                        message: "請輸入統一編號",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.vatNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "vatNumber", $$v)
                      },
                      expression: "formData.vatNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Mail",
                    "label-width": _vm.formLabelWidth,
                    prop: "email",
                    rules: [
                      {
                        required: true,
                        message: "請輸email",
                        trigger: "blur",
                      },
                      {
                        required: true,
                        pattern: _vm.pattern.email,
                        message: "mail格式不正確",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "地址",
                    "label-width": _vm.formLabelWidth,
                    prop: "addr",
                    rules: [
                      { required: true, message: "請輸地址", trigger: "blur" },
                    ],
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("el-form-item", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zipCode,
                                  expression: "zipCode",
                                },
                              ],
                              staticStyle: {
                                width: "70px",
                                margin: "12px",
                                color: "red",
                              },
                              attrs: { readonly: true, type: "text" },
                              domProps: { value: _vm.zipCode },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.zipCode = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "city",
                                rules: [
                                  {
                                    required: true,
                                    message: "請選擇縣市",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { margin: "5px", width: "100%" },
                                  attrs: {
                                    size: "mini",
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇縣市",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getTaiwanCitiesOption(2, true)
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.city,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "city", $$v)
                                    },
                                    expression: "formData.city",
                                  },
                                },
                                _vm._l(_vm.twCityOptions, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: { label: item, value: item },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "site",
                                rules: [
                                  {
                                    required: true,
                                    message: "請選擇行政區域",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { margin: "5px", width: "100%" },
                                  attrs: {
                                    size: "mini",
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇行政區域",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getTaiwanCitiesOption(3, true)
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.site,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "site", $$v)
                                    },
                                    expression: "formData.site",
                                  },
                                },
                                _vm._l(_vm.twSiteOptions, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: { label: item, value: item },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "road",
                                rules: [
                                  {
                                    required: true,
                                    message: "請選擇路名",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { margin: "5px", width: "100%" },
                                  attrs: {
                                    size: "mini",
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇路名",
                                  },
                                  on: { change: _vm.getTaiwanCitiesZipCode },
                                  model: {
                                    value: _vm.formData.road,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "road", $$v)
                                    },
                                    expression: "formData.road",
                                  },
                                },
                                _vm._l(_vm.twRoadOptions, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: { label: item, value: item },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off" },
                            model: {
                              value: _vm.formData.addr,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "addr", $$v)
                              },
                              expression: "formData.addr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "付款日",
                    "label-width": _vm.formLabelWidth,
                    prop: "paymentDate",
                    rules: [
                      {
                        required: true,
                        message: "請選擇付款日",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { margin: "5px", width: "50%" },
                      attrs: {
                        size: "mini",
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇付款日",
                      },
                      model: {
                        value: _vm.formData.paymentDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "paymentDate", $$v)
                        },
                        expression: "formData.paymentDate",
                      },
                    },
                    _vm._l(_vm.checkOutDates, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                  _vm._v(" 日 "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "結帳日",
                    "label-width": _vm.formLabelWidth,
                    prop: "checkOutDate",
                    rules: [
                      {
                        required: true,
                        message: "請選擇結帳日",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { margin: "5px", width: "50%" },
                      attrs: {
                        size: "mini",
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇結帳日",
                      },
                      model: {
                        value: _vm.formData.checkOutDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "checkOutDate", $$v)
                        },
                        expression: "formData.checkOutDate",
                      },
                    },
                    _vm._l(_vm.checkOutDates, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                  _vm._v(" 日 "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "電話",
                    "label-width": _vm.formLabelWidth,
                    prop: "tel",
                    rules: [
                      {
                        required: true,
                        message: "請輸入電話",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "tel", $$v)
                      },
                      expression: "formData.tel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "負責人",
                    "label-width": _vm.formLabelWidth,
                    prop: "boss",
                    rules: [
                      {
                        required: true,
                        message: "請輸負責人",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.boss,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "boss", $$v)
                      },
                      expression: "formData.boss",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "代表圖", "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "div",
                    [
                      _c("Upload", {
                        ref: "uploadRef",
                        attrs: {
                          payload: _vm.formData,
                          accept: ".jpg,.jpeg,.png",
                          limitText:
                            "請上傳正方形圖片以利APP呈現，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                          "data-obj": _vm.fileObj,
                          "use-drag": false,
                          action: "Agency/saveAgency",
                          "auto-upload": false,
                          "show-file-list": true,
                          "form-on-loading-parent": _vm.formOnLoading,
                          "btn-txt": "上傳",
                          "before-file-list":
                            _vm.formData.fileInfo &&
                            _vm.formData.fileInfo.length
                              ? _vm.formData.fileInfo[0].files
                              : [],
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "領隊資料維護",
            visible: _vm.dialogLeaderFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLeaderFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("leader-data", {
                attrs: { "agency-code": _vm.leaderAgecnyCode },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLeaderFormVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "試用設定", visible: _vm.dialogFreeDateFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFreeDateFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "試用區間" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      align: "right",
                      "range-separator": "至",
                      "start-placeholder": "開始日期",
                      "end-placeholder": "結束日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.freeDateForm.freeDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.freeDateForm, "freeDate", $$v)
                      },
                      expression: "freeDateForm.freeDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFreeDateFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAgencyFreeDate },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "【" + _vm.promotionalPlanForm.agencyName + "】折抵金額人數設定",
            visible: _vm.dialogPromotionalPlanFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPromotionalPlanFormVisible = $event
            },
            closed: _vm.handleClosedPromotionalPlanFormDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "selectedPromotionalPlanFormRef",
              attrs: {
                model: _vm.promotionalPlanForm,
                "label-width": "80px",
                "label-position": "right",
                rules: _vm.promotionalPlanFormRules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "使用方案", prop: "plan" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-full-select",
                      attrs: {
                        "value-key": "id",
                        placeholder: "請選擇方案",
                        filterable: "",
                        "default-first-option": "",
                      },
                      on: { change: _vm.handlePromotionalPlanChange },
                      model: {
                        value: _vm.promotionalPlanForm.plan,
                        callback: function ($$v) {
                          _vm.$set(_vm.promotionalPlanForm, "plan", $$v)
                        },
                        expression: "promotionalPlanForm.plan",
                      },
                    },
                    _vm._l(
                      _vm.promotionalPlanOptions,
                      function (promotionalPlan) {
                        return _c(
                          "el-option",
                          {
                            key: promotionalPlan.id,
                            attrs: {
                              value: promotionalPlan,
                              label: promotionalPlan.name,
                            },
                          },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(promotionalPlan.name)),
                            ]),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: promotionalPlan.startDate,
                                    expression: "promotionalPlan.startDate",
                                  },
                                ],
                                staticStyle: {
                                  float: "right",
                                  color: "#8492a6",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(promotionalPlan.startDate) +
                                    "~" +
                                    _vm._s(promotionalPlan.endDate)
                                ),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              !!_vm.promotionalPlanForm.plan
                ? _c(
                    "el-form-item",
                    { attrs: { label: "使用日期", prop: "date" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "w-full-date",
                        attrs: {
                          type: "daterange",
                          align: "right",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                          "value-format": "yyyy-MM-dd",
                          disabled:
                            !!_vm.promotionalPlanForm.plan.startDate &&
                            !!_vm.promotionalPlanForm.plan.endDate,
                        },
                        model: {
                          value: _vm.promotionalPlanForm.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.promotionalPlanForm, "date", $$v)
                          },
                          expression: "promotionalPlanForm.date",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogPromotionalPlanFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAgencyPromotionalPlan },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "AI設定", visible: _vm.dialogAISettingVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAISettingVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    label: "AIAgent",
                    "label-width": _vm.formLabelWidth,
                    prop: "aiAgentSecret",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      !_vm.aiDataForm.aiAgentSecret
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.handleGenerateChatAgent },
                            },
                            [_vm._v("生成 ")]
                          )
                        : _c(
                            "el-tag",
                            {
                              staticStyle: { "font-size": "14px" },
                              attrs: { type: "success" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.aiDataForm.aiAgentSecret) + " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "APP AI",
                    "label-width": _vm.formLabelWidth,
                    prop: "appAIUrl",
                    rules: [
                      {
                        required: false,
                        message: "請輸入APP AI URL",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.aiDataForm.appAIUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.aiDataForm, "appAIUrl", $$v)
                      },
                      expression: "aiDataForm.appAIUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "WEB AI",
                    "label-width": _vm.formLabelWidth,
                    prop: "webAIUrl",
                    rules: [
                      {
                        required: false,
                        message: "請輸入WEB AI URL",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.aiDataForm.webAIUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.aiDataForm, "webAIUrl", $$v)
                      },
                      expression: "aiDataForm.webAIUrl",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogAISettingVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAISetting },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "代碼查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入代碼" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查詢")]
              ),
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.addData } },
                [_vm._v("建立")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-button", {
                staticStyle: { cursor: "pointer" },
                attrs: {
                  size: "mini",
                  loading: _vm.listLoading,
                  type: "success",
                  icon: "el-icon-refresh-left",
                  circle: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.refresh()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "40" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "代碼", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.agencyCode))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "名稱", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.agencyName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "統編", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.vatNumber))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "電話", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.tel))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "負責人", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.boss))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "領隊管理", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editLeaderInfoData(scope.row)
                              },
                            },
                          },
                          [_vm._v("領隊維護")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "試用設定", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      scope.row.freeDateInfo.freeStartDate &&
                                      scope.row.freeDateInfo.freeEndDate,
                                    expression:
                                      "scope.row.freeDateInfo.freeStartDate && scope.row.freeDateInfo.freeEndDate",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.freeDateInfo.isFree,
                                        expression:
                                          "scope.row.freeDateInfo.isFree",
                                      },
                                    ],
                                    attrs: { placement: "top" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(
                                          "剩餘試用天數：" +
                                            _vm._s(
                                              scope.row.freeDateInfo.diffDays
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          cursor: "default",
                                          color: "red",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.freeDateInfo
                                                .freeStartDate
                                            ) +
                                            " 至 " +
                                            _vm._s(
                                              scope.row.freeDateInfo.freeEndDate
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !scope.row.freeDateInfo.isFree,
                                        expression:
                                          "!scope.row.freeDateInfo.isFree",
                                      },
                                    ],
                                    staticStyle: { cursor: "default" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.freeDateInfo.freeStartDate
                                        ) +
                                        " 至 " +
                                        _vm._s(
                                          scope.row.freeDateInfo.freeEndDate
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editAgencyFreeDate(scope.row)
                                  },
                                },
                              },
                              [_vm._v("設定")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "折抵金額人數", width: "400" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.promotionalPlan
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  gap: "6px 0",
                                  "justify-content": "center",
                                  "align-items": "center",
                                  width: "100%",
                                },
                              },
                              _vm._l(
                                scope.row.promotionalPlan,
                                function (promotionalPlanItem) {
                                  return _c(
                                    "div",
                                    {
                                      key: promotionalPlanItem.planId,
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "0 8px",
                                            "justify-content": "space-between",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    promotionalPlanItem.name
                                                  ) +
                                                  " "
                                              ),
                                              promotionalPlanItem.initBalance
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              promotionalPlanItem.initBalance.toLocaleString()
                                                            ) +
                                                            "元 "
                                                        ),
                                                      ]
                                                    ),
                                                    promotionalPlanItem.availableBalance
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#959595",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  promotionalPlanItem.availableBalance.toLocaleString()
                                                                ) +
                                                                ") "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ])
                                                : _vm._e(),
                                              promotionalPlanItem.initHeadCount
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              promotionalPlanItem.initHeadCount.toLocaleString()
                                                            ) +
                                                            "人 "
                                                        ),
                                                      ]
                                                    ),
                                                    promotionalPlanItem.remainingHeadCount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#959595",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  promotionalPlanItem.remainingHeadCount.toLocaleString()
                                                                ) +
                                                                ") "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    promotionalPlanItem.startDate
                                                  ) +
                                                  " 至 " +
                                                  _vm._s(
                                                    promotionalPlanItem.endDate
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (promotionalPlanItem.initBalance &&
                                                      promotionalPlanItem.initBalance ===
                                                        promotionalPlanItem.availableBalance) ||
                                                    (promotionalPlanItem.initHeadCount &&
                                                      promotionalPlanItem.initHeadCount ===
                                                        promotionalPlanItem.remainingHeadCount),
                                                  expression:
                                                    "\n                    (promotionalPlanItem.initBalance &&\n                      promotionalPlanItem.initBalance === promotionalPlanItem.availableBalance) ||\n                    (promotionalPlanItem.initHeadCount &&\n                      promotionalPlanItem.initHeadCount ===\n                        promotionalPlanItem.remainingHeadCount)\n                  ",
                                                },
                                              ],
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDeleteAgencyPromotionalPlan(
                                                    promotionalPlanItem
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("刪除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        !scope.row.promotionalPlan ||
                        (scope.row.promotionalPlan &&
                          scope.row.promotionalPlan.length === 0)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editAgencyPromotionalPlan(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("設定")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "AI設定", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editAISetting(scope.row)
                                  },
                                },
                              },
                              [_vm._v("設定")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "語音翻譯功能", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-text": "開", "inactive-text": "關" },
                          on: {
                            change: function ($event) {
                              return _vm.handleSwitchChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.isVoiceTranslation,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isVoiceTranslation", $$v)
                            },
                            expression: "scope.row.isVoiceTranslation",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0", "margin-top": "15px" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }